export const INITIALIZE_APP_STARTED = 'INITIALIZE_APP_STARTED';
export const INITIALIZE_APP_SUCCESS = 'INITIALIZE_APP_SUCCESS';
export const INITIALIZE_APP_FAILED = 'INITIALIZE_APP_FAILED';

export const FETCH_INSTITUTION_SUCCESS = 'FETCH_INSTITUTION_SUCCESS';
export const FETCH_CURRENT_USER_SUCCESS = 'FETCH_CURRENT_USER_SUCCESS';
export const FETCH_ACCESS_TOKEN_STARTED = 'FETCH_ACCESS_TOKEN_STARTED';
export const FETCH_ACCESS_TOKEN_SUCCESS = 'FETCH_ACCESS_TOKEN_SUCCESS';
export const FETCH_ACCESS_TOKEN_FAILED = 'FETCH_ACCESS_TOKEN_FAILED';
export const FETCH_USER_INFO_ON_SPACES_SUCCESS =
  'FETCH_USER_INFO_ON_SPACES_SUCCESS';

export const CHANGE_CURRENT_SPACE = 'CHANGE_CURRENT_SPACE';
